import React, { useEffect, useState } from 'react';
import { Form, InputGroup, Modal, Alert } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import { fetchData, putData } from '../common/Api';
import { useAuth } from '../common/AuthProvider';
import UserSubscription from './UserSubscription';
import '../styles.css';



const ProfilePage = () => {
    const history = useHistory();
    const [error, setError] = useState('');
    const [plan, setPlan] = useState('');
    const [user, setUser] = useState({});
    const [newUsername, setNewUsername] = useState('');
    const [showChangePasswModal, setShowChangePasswModal] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showNewPassword2, setShowNewPassword2] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [passwordNotEligible, setPasswordNotEligible] = useState(false);
    const [showPasswordUpdatedNotification, setShowPasswordUpdatedNotification] = useState(false);
    const [showProfileUpdatedNotification, setShowProfileUpdatedNotification] = useState(false);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await fetchData(`/api/v1/users/current`);
                setUser(response.data);
                setNewUsername(response.data.name);
            } catch (error) {
                setError(error);
            }
        };
        fetchUser();
    }, [showProfileUpdatedNotification]);

    useEffect(() => {
        if (newPassword.length > 0 && newPassword2.length > 0) {
            if (newPassword.length < 8) {
                setPasswordError('Password must be at least 8 characters long.');
                setPasswordNotEligible(true);
            } else if (!/\d/.test(newPassword)) {
                setPasswordError('Password must contain at least one number.');
                setPasswordNotEligible(true);
            } else if (newPassword !== newPassword2) {
                setPasswordError('Passwords do not match.');
                setPasswordNotEligible(true);
            } else {
                setPasswordError('');
                setPasswordNotEligible(false);
            }
        }
    }, [newPassword, newPassword2]);

    useEffect(() => {
        if (Object.keys(user).length > 0) {

            if (user.active_subscription !== undefined 
                && user.active_subscription !== null) {
                
                user.active_subscription !== undefined 
                    && user.active_subscription !== null 
                    && setPlan(user.active_subscription.plan);

            }
        }
    }, [user]);

    useEffect(() => {
        if (error) {
            if (error.status === 401) {
                history.push('/login');
            } else {
                setError(null);
            }
        }
    }, [error]);

    const cancelPasswordChange = () => {
        setNewPassword('');
        setNewPassword2('');
        setShowNewPassword(false);
        setShowNewPassword2(false);
        setPasswordError('');
        setShowChangePasswModal(false);
    }

    const handleCancelChanges = () => {
        setNewUsername(user.name);
        setNewPassword('');
        setNewPassword2('');
        setShowNewPassword(false);
        setShowNewPassword2(false);
        setPasswordError('');
        setShowChangePasswModal(false);
        setShowPasswordUpdatedNotification(false);
        setShowProfileUpdatedNotification(false);
    }

    const handleProfileUpdate = () => {
        const payload = {
            username: (newUsername !== user.name && newUsername !== '') ? newUsername : null,
            password: newPassword !== '' ? newPassword : null
        }

        const updateProfile = async () => {
            try {
                await putData(`/api/v1/user/update`, payload);
                setShowProfileUpdatedNotification(true);
            } catch (error) {
                setError(error);
            }
        };
        if ((newUsername !== '' && newUsername !== user.name) || newPassword !== '') {
            updateProfile();
        } else {
            alert('Nothing to update.'); 
        }
    }

    return (
        <>
        <div className='profile-container'>
            <h2>Profile</h2>
            <Form>
                {/* User name: can modify */}
                <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>User name</Form.Label>
                    <Form.Control 
                        autoComplete="off"
                        type="text" 
                        placeholder={newUsername}
                        onChange={(e) => setNewUsername(e.target.value)} 
                    />
                    <Form.Text className="text-muted">
                        User since {user.created_at}.
                    </Form.Text>
                </Form.Group>

                {/* Password component */}
                <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <InputGroup>
                    <Form.Control 
                        type="password"
                        placeholder="*************"
                        disabled readOnly/>
                </InputGroup>
                <Form.Text className="text-muted">
                    Last modified on {user.password_updated_at}.
                </Form.Text>

                <br/>
                <button className='btn-custom blue' type="button"
                    style={{margin: '0.5rem 0rem'}}
                    onClick={() => setShowChangePasswModal(true)}>Update password
                </button>

                {showPasswordUpdatedNotification && (
                    <Alert variant="success" onClose={() => {
                        setShowPasswordUpdatedNotification(false)}} dismissible>
                        New password setup. Save changes before closing profile page.
                    </Alert>
                )}
                </Form.Group>
                
                <Modal show={showChangePasswModal} onHide={() => 
                        cancelPasswordChange()}>
                    <Modal.Header closeButton>
                        <Modal.Title>Change Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicNewPassword">
                        <Form.Label>New Password</Form.Label>
                        <InputGroup>
                            <Form.Control type={showNewPassword ? "text" : "password"} 
                                placeholder={(newPassword !== '' && newPassword !== user.name) ? 
                                    newPassword : 
                                    "New Password"}
                                value={newPassword} onChange={(e) => {
                                    setNewPassword(e.target.value)
                                    setPasswordError('');
                                }}/>
                            <InputGroup.Text onClick={() => 
                                setShowNewPassword(!showNewPassword)}>
                                {showNewPassword ? <EyeSlash /> : <Eye />}
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicNewPassword2">
                        <Form.Label>Confirm New Password</Form.Label>
                        <InputGroup>
                            <Form.Control type={showNewPassword2 ? "text" : "password"} 
                                placeholder={newPassword2 !== '' ? 
                                    newPassword2 : 
                                    "Confirm New Password"}
                                value={newPassword2} onChange
                                ={(e) => {
                                    setNewPassword2(e.target.value);
                                    setPasswordError('');
                                    }}/>
                            <InputGroup.Text onClick={() => 
                                setShowNewPassword2(!showNewPassword2)}>
                                {showNewPassword2 ? <EyeSlash /> : <Eye />}
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                    <div className='btn-container'>
                    <button className='btn-custom-flex blue' onClick={() => {
                        cancelPasswordChange();
                    }}>No</button>
                    <button className='btn-custom-flex green' onClick={() => {
                        setShowPasswordUpdatedNotification(true);
                        setShowChangePasswModal(false);
                    }}  disabled={newPassword !== newPassword2 || 
                                    passwordNotEligible }>Yes</button>
                    </div>
                    <Alert variant="danger" 
                        style={{display: passwordError ? 'block' : 'none', 
                        margin: '0.5rem 0rem'}}>
                        {passwordError}
                    </Alert>
                </Modal.Body>
            </Modal>

            {/* User email: cannot modify */}
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control 
                    type="text" 
                    placeholder={user.email || ''} 
                    disabled 
                    readOnly 
                />
                <Form.Text className="text-muted">
                    Email address cannot be modified.
                </Form.Text>
            </Form.Group>

            {/* User subscription -> modify in the subscriptions page */}
            {user.active_subscription ? (
                <Form.Group 
                    className="mb-0" 
                    controlId="formBasicSubscription"
                >
                <Form.Label>Subscription</Form.Label>
                <Form.Control 
                    autoComplete="off"
                    type="text" 
                    placeholder={plan || ''} 
                    disabled 
                    readOnly 
                />
                <UserSubscription />
                </Form.Group>
            ) : (
                <div>
                    No active subscription. Subscribe <Link to="/plans">here</Link>.
                </div>
            )}
            {showProfileUpdatedNotification && (
                <Alert variant="success" onClose={() => {
                    setShowProfileUpdatedNotification(false)}} dismissible>
                    Profile updated successfully.
                </Alert>
            )}
            <div className='btn-group-custom' 
                style={{marginTop: '0rem'}}> 
                <button className='btn-custom green' type="button"
                    onClick={() => handleProfileUpdate()}>Save changes
                </button>
                <button className='btn-custom blue' type="button"
                    onClick={() => handleCancelChanges()}>Cancel
                </button> 
            </div>

            </Form>
        </div>
        </>        
    );
};

export default ProfilePage;
